import * as tf from '@tensorflow/tfjs-core';
import * as posedetection from "@tensorflow-models/pose-detection";
import * as mpPose from "@mediapipe/pose";

export class PoseEstimation {
  constructor(model, options) {
    this.model = model;
    this.modelConfig = {maxPoses: 1, type: options.pose.modelType, scoreThreshold: 0.65, render3D: false}
    this.backend = options.pose.backend
    this.flags = {};
    this.detector = null;
  }

  async estimatePoses(image) {
    if (!this.detector) {
      return
    }

    try {
      const config = {maxPoses: this.modelConfig.maxPoses, flipHorizontal: false}
      return await this.detector.estimatePoses(image, config);
    } catch (error) {
      // console.error(error);
      // this.detector.dispose();
      this.detector = null;
    }
  }

  async setBackendAndEnvFlags(flagConfig, backend) {
    tf.env().setFlags(flagConfig);

    const [runtime, $backend] = backend.split('-');

    if (runtime === 'tfjs') {
      await this.resetBackend($backend);
    }
  }

  async resetBackend(backendName) {
    const ENGINE = tf.engine();
    if (!(backendName in ENGINE.registryFactory)) {
      throw new Error(`${backendName} backend is not registed.`);
    }

    if (backendName in ENGINE.registry) {
      const backendFactory = tf.findBackendFactory(backendName);
      tf.removeBackend(backendName);
      tf.registerBackend(backendName, backendFactory);
    }

    await tf.setBackend(backendName);
  }

  async createDetector() {
    let config;
    switch (this.model) {
      case posedetection.SupportedModels.PoseNet:
        config = {
          quantBytes: 4,
          architecture: 'MobileNetV1',
          outputStride: 16,
          inputResolution: {width: 500, height: 500},
          multiplier: 0.75
        }
        break;
      case posedetection.SupportedModels.BlazePose:
        const runtime = this.backend.split('-')[0];
        if (runtime === 'mediapipe') {
          config = {
            runtime,
            modelType: this.modelConfig.type,
            solutionPath: `https://cdn.jsdelivr.net/npm/@mediapipe/pose@${mpPose.VERSION}`
          }
        } else if (runtime === 'tfjs') {
          config = {runtime, modelType: this.modelConfig.type}
        }
        break;
      case posedetection.SupportedModels.MoveNet:
        let modelType;
        if (this.modelConfig.type === 'lightning') {
          modelType = posedetection.movenet.modelType.SINGLEPOSE_LIGHTNING;
        } else if (this.modelConfig.type === 'thunder') {
          modelType = posedetection.movenet.modelType.SINGLEPOSE_THUNDER;
        } else if (this.modelConfig.type === 'multipose') {
          modelType = posedetection.movenet.modelType.MULTIPOSE_LIGHTNING;
        }
        const modelConfig = {modelType};

        if (this.modelConfig.customModel !== '') {
          modelConfig.modelUrl = this.modelConfig.customModel;
        }
        if (this.modelConfig.type === 'multipose') {
          modelConfig.enableTracking = this.modelConfig.enableTracking;
        }
        config = modelConfig
        break;
    }
    // console.log(config)
    this.detector = await posedetection.createDetector(this.model, config)
  }
}

const BACKEND_FLAGS_MAP = {
  ['tfjs-wasm']: ['WASM_HAS_SIMD_SUPPORT', 'WASM_HAS_MULTITHREAD_SUPPORT'],
  ['tfjs-webgl']: [
    'WEBGL_VERSION', 'WEBGL_CPU_FORWARD', 'WEBGL_PACK',
    'WEBGL_FORCE_F16_TEXTURES', 'WEBGL_RENDER_FLOAT32_CAPABLE',
    'WEBGL_FLUSH_THRESHOLD'
  ],
  ['mediapipe-gpu']: []
};



// WEBPACK FOOTER //
// ./src/components/common/PoseEstimation.js